import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { ENV_CONFIG } from 'config/environment';

export const HowOathWorks = () => {
  return (
    <div className="how-oath-works-header">
      <div className="how-oath-works-title">
        <FadeText className="eyebrow-text" text="How Oath Works" />
        <FadeText delay={0.3} progressive className="h1-dtm" text="Oath's Impact Score" />
        <FadeText
          delay={0.5}
          className="h4-text"
          text="The heart of Oath’s model is the Impact Score. Our proprietary algorithm analyzes thousands of races across dozens of data points to rate the relative value of your donation in each race."
        />
      </div>
      <FadeContainer delay={0.7} animateNow>
        <video
          autoPlay
          loop
          muted
          playsInline
          src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/videos/ImpactScore.mp4`}
        />
      </FadeContainer>
    </div>
  );
};
